module.exports = __webpack_public_path__ + "media/basic-details/lite@2x-8cfb6a10.png";